import styled from 'styled-components';

const Container = styled.footer`
  width: 100%;
`;

const FooterTop = styled.div`
  padding: 20px;
  background: #fefff8;
`;

const ResturantInfo = styled.p`
  color: #333;
  line-height: 2;
`;

const FooterBottom = styled.div`
  padding: 10px;
  background: #BF0436;
  color: white;
  text-align: center;
`;

export default function Footer() {
  return (
    <Container>
      <FooterTop>
        <ResturantInfo>
          Address: 64 Rue Mokhtar Attia, Tunis 1000 , Tunisie <br />
          Contact us：+216 31 198 000  <br />
          Opening hours：Monday ➝ Saturday │ 08:30 • 17:00
          <br />
          Email：contact@horizoninformatique.tn
          <br />
        </ResturantInfo>
      </FooterTop>
      <FooterBottom>
        Copyright © 2022. The 715 Lounge Coffee
      </FooterBottom>
    </Container>
  );
}